import React, { useEffect, useRef, useState } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import { apiHelper } from "../../lib/ApiHelper";
import "./StyleSheet.css";
import PRHLoader from '../../lib/PRHLoader';
import { AgGridReact } from "@ag-grid-community/react";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import "@ag-grid-community/styles/ag-theme-balham.css";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
ModuleRegistry.registerModules([
    ClientSideRowModelModule
]);
import { LicenseManager } from "@ag-grid-enterprise/core";
LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-058820}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Penguin_Random_House_LLC}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{InventoryHub}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{InventoryHub}_need_to_be_licensed___{InventoryHub}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{4_April_2025}____[v3]_[01]_MTc0MzcyMTIwMDAwMA==a87b1efc2ee2da35884b94c846d80314");
import "../MainBox.css";
import NotesPopUpDK from "./NotesPopUp-DK";

export default function NotesDK(props) {
    const [noteId, setNoteId] = useState(0);
    const isHoveringRef = useRef(false);
    const [toolTipId, setToolTipId] = useState(0);
    const tooltipRef = useRef(null);
    const [openPopup, setOpenPopup] = useState(false);
    const [rowData, setRowData] = useState([]);
    const latestCallVersion = useRef(0);
    const [rowDataLoading, setRowDataLoading] = useState(false);
    const [searchNoteText, setSearchNoteText] = useState(null);
   
    const [isSearchedData, setIsSearchedData] = useState(false);
    const debounceTimer = useRef(null);

    const gridOptions = {
        defaultColDef: {
            resizable: true,
            sortable: true,
        },
        popupParent: document.body,
        animateRows: true,
        accentedSort: true,
        suppressRowClickSelection: true,
        // onGridReady: (event) => event.api.sizeColumnsToFit(),

    }
    const onGridReady = (params) => {

        const allColumnIds = params.columnApi
            .getAllDisplayedColumns()
            .map((col) => col.getColId());
        params.columnApi.autoSizeColumns(allColumnIds);
    };

    const columnDefs = [
        {
            headerName: "Create Date", field: "createDate", headerClass: "HeaderClassSource header-text-right",

            cellClass: "CellClassSource cell-text-right", cellRenderer: (params) => {
                if ((params.value == '0001-01-01T00:00:00')) { return <span></span>; }
                return <span>{showFormatDate(params.value)}</span>;
            },
            /* tooltipField: "createDate"*/
        },
        {
            headerName: "Author", field: "userName", headerClass: "HeaderClassSource cell-text-left",

            cellClass: "CellClassSource-left-align",
            /*   tooltipValueGetter: (p) => p.value*/
        },
        {
            headerName: "Visibility", field: "visibility", headerClass: "HeaderClassSource cell-text-left",

            cellClass: "CellClassSource-left-align",
            /*           tooltipValueGetter: (p) => p.value*/
        },
        {
            headerName: "Status", field: "status", headerClass: "HeaderClassSource",

            cellClass: "CellClassSource-left-align",
            /*tooltipValueGetter: (p) => p.value*/
        },
        {
            headerName: "Priority", field: "priority", headerClass: "HeaderClassSource",

            cellClass: "CellClassSource-left-align",
            /*    tooltipValueGetter: (p) => p.value*/
        },
        {
            headerName: "Note", field: "note", headerClass: "HeaderClassSource",

            cellClass: "CellClassSource-left-align",
            valueFormatter: (params) => {
                const value = params.value || "";
                return value.length > 100 ? value.substring(0, 100) + "..." : value;
            }
           /* cellRenderer: (params) => {

                return <div className="note-container">
                    <span>{params.value}</span>


                </div >;
            },*/
        },

        {
            headerName: "",
            field: "note",
            headerClass: "HeaderClassSource",
            cellClass: "CellClassSource-left-align",
            width: 70,
            tooltipValueGetter: (params) => {
                return params.data?.note;
            },
            cellRenderer: (params) => {
                return (
                    <button className="notes-ISBNSubmit preview-font-size ml-1">
                        <span style={{ display: "inline-block" }}>Preview</span>
                    </button>
                );
            },
            //tooltipComponentParams: { /* optional styling parameters */ }
        }

    ]

    const onRowClicked = async (event) => {
        const data = JSON.stringify(event.data.noteID);
        setNoteId(data);
        setOpenPopup(true);
    };
/*
    const ObBlurHandle = () => {
        // const related = e.relatedTarget;
        // if (e?.currentTarget?.contains(related)) return;

        isHoveringRef.current = false;

        setTooltipInfo({
            visible: false,
            x: 0,
            y: 0,
            content: "",
            width: "0ch",
        });


    }*/
    /*   useEffect(() => {
           const handleWindowMouseLeave = () => {
               isHoveringRef.current = false;
               setTooltipInfo({
                   visible: false,
                   x: 0,
                   y: 0,
                   content: "",
                   width: "0ch",
               });
           };
   
           window.addEventListener("mouseleave", handleWindowMouseLeave);
           return () => {
               window.removeEventListener("mouseleave", handleWindowMouseLeave);
           };
       }, []);
   */

    const callNote = async (id, version) => {
        clearTimeout(debounceTimer.current);

        return new Promise((resolve) => {
            debounceTimer.current = setTimeout(async () => {
                const result = await getNotes(id); // Await actual data
                if (version === latestCallVersion.current) {
                    resolve(result);
                } else {
                    resolve("Loading..."); // Or resolve early with no update
                }
            }, 500);
        });
    };


    const getNotes = async (id) => {
        try {
            if (id > 0 && toolTipId != id) {

                const data = await apiHelper.inventoryPostCall("getNotes", { value: id });
                if (data) {

                    return data.note;
                } else {

                    return "No Data Available";
                }
            }
        } catch (e) {
            console.error("get note for tootip failed", e);
        }
    }


    const showFormatDate = (dateString) => {
        if (dateString) {
            const date = new Date(dateString);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const formattedDate = `${month}/${day}/${year}`;
            return formattedDate;
        }
        return null;
    }



    const closePopUp = () => {
        setOpenPopup(false);
    }
    const newPopup = () => {
        setNoteId(0);
        setOpenPopup(true);
    }
    const getShortNotes = async (loadAll) => {
        try {
            setRowDataLoading(true);
            setRowData([]);
            setIsSearchedData(!loadAll);
            if (loadAll) {
                setSearchNoteText(null);
            }

            if (!props.ISBNId || props.ISBNId.trim().length == 0) {
                return;
            }
            var res = await apiHelper.inventoryPostCall("getShortNotes", {
                ISBN: props.ISBNId,
                RequestUPN: props.upn,
                SearchText: loadAll ? null : searchNoteText
            });
            if (res != undefined && res != null) {
                setRowData(res);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setRowDataLoading(false);
        }
    }
    const clearSearch = () => {
        setSearchNoteText(null);
        getShortNotes(true);
    }

    useEffect(() => {
        getShortNotes(true);
    }, [props.metaData, props.onchangeNote])


    return (<>
        {/*        <div className="notes-container container-fluid" onMouseLeave={() => {
            isHoveringRef.current = false;
            //latestCallVersion.current++;

            // Use timeout to give buffer for fast movement
            *//*  setTimeout(() => {
                  if (!isHoveringRef.current) {*//*
            setTooltipInfo({
                visible: false,
                x: 0,
                y: 0,
                content: "",
                width: "0ch",
            });
        }}>*/}
        <div className="notes-container container-fluid">
            <div className="short-notes" >

                <Row>
                    <Col>

                        <Form.Group>
                            {(props.isMetaLoading || rowDataLoading) && <PRHLoader />}
                            <Form.Label>ZMUP Comments</Form.Label>
                            <input className='custom-input left-p-input width100Per'
                                value={props.metaData != null && props.metaData != undefined ? props.metaData?.zmupComment1 : ''} disabled></input>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label>Inventory Note</Form.Label>
                            <input className='custom-input left-p-input width100Per'
                                value={props.metaData != null && props.metaData != undefined ? props.metaData?.zmupComment2 : ''} disabled></input>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={2}>
                        <Form.Group>
                            <Form.Label>Corp Priority</Form.Label>
                            <input className='custom-input left-p-input width100Per'
                                value={props.metaData != null && props.metaData != undefined ? (props.metaData?.corpPriority ?? '') : ''} disabled></input>
                        </Form.Group>
                    </Col>
                    <Col md={2}>
                        <Form.Group>
                            <Form.Label>Ops Comment</Form.Label>
                            <input className='custom-input left-p-input width100Per'
                                value={props.metaData != null && props.metaData != undefined ? (props.metaData?.opsComment ?? '') : ''} disabled></input>
                        </Form.Group>
                    </Col> <Col md={2}>
                        <Form.Group>
                            <Form.Label>NR/Sched Note</Form.Label>
                            <input className='custom-input left-p-input width100Per'
                                value={props.metaData != null && props.metaData != undefined ? (props.metaData?.nrSchedNote ?? '') : ''} disabled></input>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="search-bar">
                    <Col>
                        <button className="ISBNSubmit ml-3"
                            disabled={!props.ISBNId || props.ISBNId?.trim().length == 0 || props?.metaData.access != 'm'}
                            onClick={newPopup}>Add New Note</button>
                    </Col>
                    <Col className="search-input">
                        <input type='text'
                            className="custom-input"
                            id='searchText' name='searchText'
                            placeholder='Search notes'
                            value={searchNoteText || ''}
                            disabled={!props.ISBNId || props.ISBNId?.trim().length == 0}
                            onChange={(e) => setSearchNoteText(e.target.value)}
                            onKeyDown={(e) => { if (e.key.toLowerCase() == 'enter') { getShortNotes(false); } }}
                        />
                        <button className="ISBNSubmit ml-3"
                            disabled={!searchNoteText || searchNoteText.trim() == 0 || !props.ISBNId || props.ISBNId?.trim().length == 0}
                            onClick={() => getShortNotes(false)}
                        >Search</button>
                        <button className="ISBNSubmit ml-3"
                            disabled={!isSearchedData || !props.ISBNId || props.ISBNId?.trim().length == 0 }
                            onClick={clearSearch}
                        >Clear</button>
                    </Col>
                </Row>

                {rowData && rowData.length > 0 ? /*<div className="custom mb-1 pt-3 pr-3 pb-3" style={{ height: "180px" }} onMouseEnter={() => {
                    isHoveringRef.current = false;
                  //      latestCallVersion.current++;

                    // Use timeout to give buffer for fast movement
                    *//*  setTimeout(() => {
                          if (!isHoveringRef.current) {*//*
                    setTooltipInfo({
                        visible: false,
                        x: 0,
                        y: 0,
                        content: "",
                        width: "0ch",
                    });
                    *//*    }
                  }, 200);*//*
                }}>*/
                    <div className="custom mb-1 pt-3 pr-3 pb-3" style={{ height: "180px" }}>

                    {/*{isHoveringRef.current && tooltipInfo.visible && <div
                        className="tooltip-review"
                        ref={tooltipRef}
                        style={{
                            top: tooltipInfo.y,
                            left: tooltipInfo.x,
                            // visibility: tooltipInfo.visible && tooltipInfo.content ? 'visible' : 'hidden',
                            width: tooltipInfo.width || '10ch',
                        }}

                    >
                        {tooltipInfo.content}
                    </div>}*/}
                    {/*      )}*/}
                    <AgGridReact
                        rowData={rowData}
                        columnDefs={columnDefs}
                        rowSelection="single"
                        onRowClicked={onRowClicked}
                        gridOptions={gridOptions}
                        onGridReady={onGridReady}
                        tooltipShowDelay={0}
                    />
                </div>
                    :
                    <></>}



            </div >{openPopup &&
                <NotesPopUpDK
                    userInitials={props.userInitials}
                    noteID={noteId}
                    ISBNId={props.ISBNId}
                    upn={props.upn}
                    onClose={closePopUp}
                    onSave={getShortNotes}
                    isEditable={props.isEditable && props?.metaData.access === 'm'}
                />}
        </div>
    </>);
}